export const getFirstLetterOfEachWord = (text) => (
    text.match(/\b\w/g).join('')
);
